import * as React from 'react';
import classnames from 'classnames';
import { currentYPosition, scrollTo } from './utils';

import toTopIcon from '../../images/Icon---Arrow---Up.svg';
import ScrollWrap from '@/components/scroll-wrap';

import * as styles from './styles.module.less';

const ToTopWrap: React.FC = () => {
  const scrollToTop = (): void => {
    const scrollY = currentYPosition();
    scrollTo(0, scrollY / 100, 'easeIn');
    // window.scrollTo({
    //   top: 0,
    //   left: 0,
    //   behavior: "smooth",
    // });
  };

  return (
    <ScrollWrap isHalfScreen onClick={scrollToTop} className={classnames(styles.back_top_container)}>
      <img src={toTopIcon} alt="to top" className={`${styles.icon_to_top}`} />
    </ScrollWrap>
  );
};

export default ToTopWrap;
